import React from "react";
import close_icon from '../../../../Assets/Icons/icon-close-white.svg';



interface Props {
    onClose?: () => void;
    children: any;
}

const SendMeet: React.FC<Props> = ({ children, onClose }) => {
    return (
        <div style={{ display: "flex", flexDirection: 'column', gap: "1rem", height: "auto", marginBottom: 15 }}>
            <div style={{ display: "flex", justifyContent: "space-between", paddingBottom: "2rem" }}>

                <p style={{ fontSize: "1rem", fontWeight: 500, color: "white", marginLeft: 10 }}>Enviar ponto de encontro</p>
                <button style={{ userSelect: "none", background: "none", border: "none" }} onClick={onClose}>
                    <img src={close_icon} alt="Fechar" />
                </button>
            </div>
            <div style={{ marginInline: "-1rem", display: "flex", alignItems: "center", justifyContent: "center", marginBottom: "4rem" }}>

                {children}
            </div>
        </div>
    )
};

export default SendMeet;